import formatPhone from 'src/functions/formatPhone'
import type { Country } from 'src/types/country'

/**
 * Публичный номер контакта, добавочный и `tel:` для ссылки.
 */
export default function getContactPhone(
  phone: string | number | undefined | null,
  additionalNumber: string | number | undefined | null,
  country?: Country,
): {
  formatted: string
  additionalFormatted: string
  rawHref: string
} {
  if (phone == null || phone === '') {
    return {
      formatted: '',
      additionalFormatted: '',
      rawHref: '',
    }
  }

  const formatted = String(formatPhone({
    phone,
    country,
  }))
  const raw = formatPhone({
    phone,
    country,
    isRaw: true,
  })
  const additionalFormatted = additionalNumber == null || additionalNumber === ''
    ? ''
    : String(formatPhone({
      phone: additionalNumber,
      country,
    }))

  return {
    formatted,
    additionalFormatted,
    rawHref: raw ? `tel:${raw}` : '',
  }
}
